import { type ApiResponse, ApiFactory } from '@/utils/api'
import type { PaymentConfirmInfoReqType, PaymentType } from '@/models/types/ecPayment.types'
import { EcPaymentEnums } from '@/constants/enums/api/ecPayment.enums'

export class EcPaymentServices extends ApiFactory {
  constructor() {
    super('')
  }

  /** 取得即將過期的機台清單 */
  getExpireAlertList = async (): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(EcPaymentEnums.getExpireAlertList)
  }

  /** 取得付款紀錄 */
  getPaymentRecords = async (): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(EcPaymentEnums.getPaymentRecords)
  }

  /** 取得付款紀錄詳細資料 */
  getPaymentRecordDetail = async (params: { merchantTradeNo: string }): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(EcPaymentEnums.getPaymentRecordDetail, params)
  }

  /** 取得付費方案清單 */
  getPlanSelections = async (params: { planId: string }): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(EcPaymentEnums.getPlanSelections, params)
  }

  /** 取得機台付款清單 */
  getPaymentDetails = async (): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(EcPaymentEnums.getPaymentDetails)
  }

  /** 取得付款確認頁內容 */
  getPaymentConfirmInfos = async (params: PaymentConfirmInfoReqType): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(EcPaymentEnums.getPaymentConfirmInfos, params)
  }

  /** 送出金流資訊 */
  sendEcPayment = async (params: PaymentType): Promise<ApiResponse> => {
    return await this.post<unknown, ApiResponse>(EcPaymentEnums.sendEcPayment, params)
  }
}
